// removed by extract-text-webpack-plugin
module.exports = {"toggleSwitch":"_18lYsHtAW_aPMfLx4vGMVZ","outerLabel":"_1tZi6_2Mj0TwsqiZRInKpM","innerLabel":"_3iQ4VSL491HZcUQu0HUTY9","toggleActive":"F87KBGKzOlGxrKpTDOOXN","toggleInactive":"_3St-mMKQWButXKErZ7-JTi","disabled":"NRT28VzAQCoyCDr5Cwfa6","toggleSwitchSmall":"_3ulg320fX5gDa5FSb5T7E1","toggleSwitchXSmall":"_1pfWLrRuMLQiNSROx0Z6lw"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/ToggleSwitch/ToggleSwitch.scss
// module id = ./node_modules/wix-style-react/dist/es/src/ToggleSwitch/ToggleSwitch.scss
// module chunks = 0